import { AdminDashboardDataFilter, AdminDashboardVenuesStaticsResponse } from '../../graphql/API';
import { adminGetDashboardVenuesData } from '../../graphql/queries';
import { executeGql, processGqlResult } from '../../utils/gql-utils';

export const adminGetDashboardVenuesDataApi = async (
  filter: AdminDashboardDataFilter,
): Promise<AdminDashboardVenuesStaticsResponse> => {
  const result = await executeGql(adminGetDashboardVenuesData, { filter });
  return processGqlResult<AdminDashboardVenuesStaticsResponse>(
    'adminGetDashboardVenuesData',
    result,
  );
};
